import {alias, createModelSchema} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {SmartOfferBundleProgressiveType} from "./SmartOfferBundleProgressiveType";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Schema} from "@/common/Schema";


export class SmartOfferBundleProgressive extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.PROGRESSIVE);

        this._type = null;
        this._currency = null;
        this._reward = null;
        this._product = null;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    valid() {

        if (!SmartOfferBundleProgressiveType.is(this.type) || SmartOfferBundleProgressiveType.isNone(this.type)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (!this.reward || !this.reward.valid()) {
            return false;
        }

        if (!this.product || !RedactorUtils.getProduct(this.product)) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleProgressive());
        } else if (target instanceof SmartOfferBundleProgressive) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleProgressive, {
    _type: alias("type", SmartOfferBundleProgressiveType.schema()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _reward: alias("reward", RewardBunch.schema()),
    _product: alias("product", Schema.primitive()),
});